import { render, staticRenderFns } from "./GenelKategori.vue?vue&type=template&id=6af053f7&scoped=true"
import script from "./GenelKategori.vue?vue&type=script&lang=js"
export * from "./GenelKategori.vue?vue&type=script&lang=js"
import style0 from "./GenelKategori.vue?vue&type=style&index=0&id=6af053f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af053f7",
  null
  
)

export default component.exports